<template>
<div class="chapter">
<div class="inner_page">
      ﻿

	
	
		
		
			
			<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>The Angel
Answer Book</title>
<p class="ser1" id="aap_2" style="margin-top:15%;"><img alt="images/img-5-1.jpg" src="images/img-5-1.jpg"/></p>
<p class="ct1" id="pAJb">
<a href="#/contents#bbp_2"><span style="color:#007467;">What the Bible Says About Angels</span></a> </p>
<p class="ser3"><img alt="images/img-20-1.jpg" id="Aop" src="images/img-20-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part02.vue?982d6b50